import { useState } from "react";
import { Box, Tooltip } from "@mui/material";
import AppModal from "../../common/AppModal";
import AppSnackbar from "../../common/AppSnackbar";
import ToolbarButton from "../../common/Toolbar-button";
import EditIcon from "../../IconComp/editIcon";
import EditNonMedicineModal from "./nonmedical-edit-model";
import ErrorToster from "../../common/ErrorToster";

interface IProps {
  getNonMedical: () => void;
  medical: any;
  EditNonMedicalTrue: boolean
}

export const EditNonMedicalToolbar = ({ medical, getNonMedical,EditNonMedicalTrue }: IProps) => {
  const [openModal, setOpenModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const [openErrorToast, setOpenErrorToast] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  return (
    <>
    <Tooltip title="Edit">
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "flex-end",
          flexWrap: "wrap",
        }}
      >
        <EditIcon onClick={handleOpenModal} />
      </Box>
      </Tooltip>
      <AppModal
        title="Edit Non Medical Product"
        open={openModal}
        handleClose={handleCloseModal}
        fullScreen={false}
        maxWidth="lg"
      >
        <EditNonMedicineModal
          getNonMedical={getNonMedical}
          handleClose={handleCloseModal}
          setOpenSnackbar={() => setOpenSnackbar(true)}
          medical={medical}
          EditNonMedicalTrue={EditNonMedicalTrue}
          setOpenErrorToast={() => setOpenErrorToast(true)}
          setErrorMessage={setErrorMessage}
        />
      </AppModal>
      <AppSnackbar
        message="Successfully Updated!"
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
      />

      <ErrorToster
        message={errorMessage}
        open={openErrorToast}
        handleClose={() => setOpenErrorToast(false)}
      />
    </>
  );
};
